module.exports = __webpack_public_path__ + "static/media/brochureSensa.026de5cd.jpg";